/**
 * Shared app alert helpers. Use instead of repeating Alert.alert(t('common.error'), ...)
 * in 4+ places. Centralizes title keys and signature.
 */
import { Alert, type AlertButton } from 'react-native';

export type TFunction = (key: string) => string;

export interface ShowAppAlertOptions {
  /** Message body (translated or plain). */
  message: string;
  /** Optional custom buttons. Default success: [{ text: t('common.ok') }]. */
  buttons?: AlertButton[];
}

/**
 * Show an error alert with title common.error. Use in 4+ places instead of
 * Alert.alert(t('common.error'), message).
 */
export function showErrorAlert(t: TFunction, options: ShowAppAlertOptions): void {
  const { message, buttons } = options;
  Alert.alert(t('common.error'), message, buttons ?? [{ text: t('common.ok') }]);
}

/**
 * Show a success alert with title common.success. Use in 4+ places instead of
 * Alert.alert(t('common.success'), message, [...]).
 */
export function showSuccessAlert(t: TFunction, options: ShowAppAlertOptions): void {
  const { message, buttons } = options;
  Alert.alert(t('common.success'), message, buttons ?? [{ text: t('common.ok') }]);
}
